import React, { Dispatch } from 'react';
import { useTranslation } from 'react-i18next';
import { Button, DialogActions, SxProps } from '@mui/material';
import { headingFontBold, vars } from '../../../../../Theme';
import { useDispatch, useSelector } from 'react-redux';
import { IAppReduxStore } from '../../../../../redux/store';
import { onConfirmUploadAdditionalDocuments } from '../../../../../redux/project/documents/sliceProjectUploadAdditionalDocuments';
import { useParams } from 'react-router-dom';
import {
    IUploadAdditionalDocumentErrorState,
    IUploadAdditionalDocumentMainState,
} from '../UploadAdditionalDocumentDialog';
import dayjs from 'dayjs';

const buttonSx: SxProps = {
    textTransform: 'none',
    fontWeight: 700,
    fontSize: '14px',
    fontFamily: headingFontBold,
    lineHeight: 'normal',
    padding: '9px 12px',
    color: vars.white,
};

export default ({
    setShowErrorState,
    mainState,
    onClose,
}: IUploadAdditionalDocumentDialogActionsProps) => {
    const { t } = useTranslation('translations', { keyPrefix: 'uploadAdditionalDocumentDialog' });
    const dispatch: Dispatch<unknown> = useDispatch();
    const params = useParams();

    const { replicaId } = params;

    const isLoading = useSelector(
        (_store: IAppReduxStore) => _store.projectUploadAdditionalDocuments.loading,
    );

    const { data: documents } = useSelector(
        (_store: IAppReduxStore) => _store.projectDocuments.info,
    );

    const fileInfo = useSelector(
        (_store: IAppReduxStore) => _store.projectUploadAdditionalDocuments.fileInfo,
    );

    const validateInput = () => {
        const isDateValidAndNotInFuture =
            dayjs(mainState.date).isValid() && dayjs(mainState.date).isBefore(dayjs());

        setShowErrorState({
            selectedDocTypeVariant: mainState.selectedDocTypeVariant === '',
            subject: mainState.subject === '',
            date: !isDateValidAndNotInFuture,
            file: fileInfo === null,
        });
        return (
            mainState.selectedDocTypeVariant !== '' &&
            mainState.subject !== '' &&
            isDateValidAndNotInFuture &&
            fileInfo !== null
        );
    };
    const onUpload = () => {
        if (validateInput()) {
            dispatch(
                onConfirmUploadAdditionalDocuments({
                    ...mainState,
                    replicaId,
                }),
            );
        }
    };
    return (
        <DialogActions sx={{ px: 3, py: 1, borderTop: `1px solid ${vars.lightGray}` }}>
            <Button
                variant={'text'}
                onClick={onClose}
                sx={{ ...buttonSx, color: vars.font }}
                disabled={isLoading}
            >
                {t('ctaCancel')}
            </Button>
            <Button
                variant={'contained'}
                onClick={onUpload}
                sx={buttonSx}
                disabled={!documents?.length || isLoading}
            >
                {t('ctaUpload')}
            </Button>
        </DialogActions>
    );
};

interface IUploadAdditionalDocumentDialogActionsProps {
    setShowErrorState: Dispatch<React.SetStateAction<IUploadAdditionalDocumentErrorState>>;
    mainState: IUploadAdditionalDocumentMainState;
    onClose: () => void;
}
